import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicServerAuthDetailsParamsRawI,
	type LWApiPublicServerAuthDetailsResultRawI,
} from '@liquidweb-dev/club-sauce/public/server/auth/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const SERVER_AUTH_DETAILS_QUERY_KEY = '/server/auth/details';

const useServerAuthDetails = (
	params: LWApiPublicServerAuthDetailsParamsRawI,
	options?: UseQueryOptions<LWApiPublicServerAuthDetailsResultRawI, ApiErrorI>,
) =>
	useQuery({
		queryKey: [SERVER_AUTH_DETAILS_QUERY_KEY, params],
		queryFn: () => api.server.auth.apiRaw.details(params),
		...options,
	});

export default useServerAuthDetails;
